import React from 'react';
import classNames from 'classnames';
import { Carousel as AntdCarousel } from 'antd';
import { CarouselRef } from 'antd/es/carousel/index';
import { ConfigContext } from '../config-provider';
import { Icon } from '../icon';
const Carousel = React.forwardRef((props, ref) => {
    const { dotsType, arrowWithIn, className: customizeClassName, ...otherProps } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('carousel', props.prefixCls);
    const className = classNames({
        [`${prefixCls}-circle-dot`]: dotsType === 'circle',
        [`${prefixCls}-arrow-within`]: !!arrowWithIn
    }, customizeClassName);
    return React.createElement(AntdCarousel, { ...otherProps, prefixCls: prefixCls, ref: ref, className: className });
});
Carousel.displayName = 'Carousel';
Carousel.defaultProps = {
    dotsType: 'line',
    dots: true,
    arrows: false,
    draggable: false,
    arrowWithIn: false,
    dotPosition: 'bottom',
    prevArrow: React.createElement(Icon, { type: 'chevron--left', size: 'middle' }),
    nextArrow: React.createElement(Icon, { type: 'chevron--right', size: 'middle' })
};
export default Carousel;
